
import Vue from "vue";
import axios from "axios";
import ProgressiveImage from "@/components/ProgressiveImage.vue";
import { prefetchStaffPhotoThumbs } from "@/utils/staffPhoto";

export default Vue.extend({
  components: { ProgressiveImage },
  props: ["post"],
  data: () => ({
    professors: [] as any,
  }),
  mounted() {
    this.getProfessorList();
  },
  methods: {
    getProfessorList() {
      axios
        .post(Vue.prototype.apiUrl("get-item-list-need"), {
          collection: "staff",
          need: { type: "professor" },
        })
        .then(async (response) => {
          this.professors = response.data;
          await prefetchStaffPhotoThumbs(this.professors);
        });
    },
  },
});
